// Lead Generation console — the manager → generator feedback (coaching notes)
// HTTP client. Rides the portal cookie (portalApi → credentials:"include"); the
// controller hard-scopes to the authenticated generator, so nothing here
// supplies an id. Mirrors LeadGenFeedbackNoteDto in
// src/PhoenixCapital.Core/DTOs/LeadGen/LeadGenFeedbackDtos.cs. Standalone from
// the compensation client (leadGenerator.ts) — its own route + surface.

import { portalApi } from "./client";

/** One coaching note, projected with the author's display name + read flag. */
export interface LeadGenFeedbackNoteDto {
  id: string;
  leadGeneratorId: string;
  authorUserId: string;
  authorName: string;
  body: string;
  category: string | null;
  weekOf: string | null;
  isRead: boolean;
  acknowledgedAtUtc: string | null;
  createdAt: string;
}

const BASE = "/lead-generator/my-feedback";

export const leadGenFeedbackApi = {
  /** My feedback, newest-first. Opening it marks every unread note read
   *  server-side (so the sidebar badge clears). */
  mine: () => portalApi.get<LeadGenFeedbackNoteDto[]>(BASE),
  /** Unread-note count for the sidebar tab badge. */
  unreadCount: () => portalApi.get<number>(`${BASE}/unread-count`),
};
